import type { RouteRecordRaw } from 'vue-router'
import { externalServiceUrls } from '@/utils/external-services'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/console/ai-cam',
  component: Layout,
  meta: {
    title: 'CAM',
    menu: false,
    link: externalServiceUrls.aiCam,
  },
  children: [
    {
      path: '',
      name: 'cam',
      component: () => import('@/views/index.vue'),
      meta: {
        title: 'CAM',
        menu: false,
        breadcrumb: false,
      },
    },
  ],
}

export default routes
